import { User } from 'store/session/user';
import { IndividualType } from 'store/individuals/individual';
import { Action, DataFor, ResourceActions } from './types';
import { ROLES } from './roles';
import type { Permissions } from './types';

export function hasPermissions<R extends keyof Permissions>(
    user: User | null | undefined,
    resource: R,
    action: Action,
    data?: DataFor<R>
): boolean {
    if (!user?.role) return false;

    const resourceMap = ROLES[user.role as IndividualType]?.[resource] as ResourceActions<R> | undefined;

    const permission = resourceMap?.[action];
    if (!permission) return false;

    if (typeof permission === 'boolean') return permission;

    if (typeof permission === 'function') {
        // If we don't provide the target data (declaration/manifest etc),
        // we assume that the user have general access to this type of resource

        // Example: hasPermissions(user, 'declarations', UPDATE) -> true
        // Example: hasPermissions(user, 'declarations', UPDATE, declaration) -> checks the condition

        if (data == null) return true;

        return permission(user, data);
    }

    return false;
}
